import { Component, Input } from '@angular/core';
import { OptionsComponent } from '../popups/options/options.component';
import { SelectPopupComponent } from '../popups/select-popup/select-popup.component';
import { NgClass, NgIf } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IdNameModel } from '../../models/idname.model';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-input-select',
  standalone: true,
  imports: [
    SelectPopupComponent,
    NgClass,
    NgIf,
    ReactiveFormsModule,
    TranslocoDirective
  ],
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss', '../input-text/input-text.component.scss']
})
export class InputSelectComponent {
  @Input() label: string = '';
  @Input() hint: string = '';
  @Input({ required: true }) formGroup = new FormGroup({ id: new FormControl<string>(''), name: new FormControl('') });
  @Input() options: IdNameModel[] = [];
  protected popupVisible: boolean = false;
  protected readonly OptionsComponent = OptionsComponent;

  protected openPopUp() {
    this.popupVisible = true;
  }

  protected setSelected(event: IdNameModel) {
    this.formGroup.setValue(event)
  }

  protected IsInValid(): boolean {
    return this.formGroup.invalid && this.formGroup.touched;
  }
}
